import React, { useState } from 'react';
import { FileUploader } from "react-drag-drop-files";

// CSS Styles with reduced padding
const styles = `
  .employee-form-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 16px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    background-color: #e2e5e8;
    min-height: 100vh;
  }

    .form-header {
    margin-bottom: 24px;
    padding-bottom: 16px;
    padding-horizontal: 20px;
    background-color: #ffffff;    
    border-radius: 8px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    border-bottom: 1px solid #e0e0e0;
  }

  .form-title-row {
    display: flex;
    justify-content: space-between;
    background: #66afce;
    align-items: center;
    margin-bottom: 8px;
  }

  .form-title {
    font-size: 24px;
    font-weight: 600;
    color: #ffffff;
    margin: 0;
    border: none;
    border-radius: 3px;
    cursor: pointer;
    transition: background-color 0.2s;
    box-sizing: border-box;
  }

  .form-subtitle {
    padding: 6px 12px;
    background: #dc3545;
    color: #ffffff;
    font-weight: 500;
    margin: 0;

     border: none;
    border-radius: 3px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;
    box-sizing: border-box;
  }

  .form-status {
    font-size: 14px;
    color: #666;
    margin: 0;
  }

  .form-content {
    background-color: #FAFAFA;
    border-radius: 4px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    overflow: hidden;
  }

  fieldset {
  padding:0 20px 20px 20px;
  margin-bottom:10px;
  border:1px solid #1E96C8;
  }
  legend {
  color: #1E96C8;
  font-weight:bold
  }

  /* Tabs Navigation */
  .tabs-navigation {
    display: flex;
     background: linear-gradient(-180deg, #f8f8f8 0%, #a9a9a9 100%);
    border-bottom: 1px solid #e0e0e0;
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .tab-item {
    padding: 12px 20px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    color: #000000;
    transition: background 0.1s, color 0.1s;
    cursor: pointer;
    border-bottom: 2px solid transparent;
    white-space: nowrap;
  }

  .tab-item:hover {
    color: #007bff;
    background-color: #ffffff;
  }

  .tab-item.active {
    color: #007bff;
    border-bottom-color: #007bff;
    background-color: #f8f9fa;
  }

  /* Tab Content */
  .tab-content {
    padding: 20px;
  }

  .tab-pane {
    display: none;
  }

  .tab-pane.active {
    display: block;
  }

  /* Form Grid */
  .form-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 16px;
  }

  .form-group {
    margin-bottom: 12px;
  }

  .form-label {
    display: block;
    font-size: 13px;
    font-weight: 500;
    color: #555;
    margin-bottom: 4px;
  }

  .required-label::after {
    content: " *";
    color: #dc3545;
  }
    
  .form-input:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
  }

  .form-input::placeholder {
    color: #050505;
    font-size: 13px;
  }

  input, textarea, select, option {
  background-color: #d9eef8;
  }
  input, textarea, select {
  padding:3px;
   height: 34px;
  border:1px solid #9adaee;
  border-radius:5px;
  width:200px;
  box-shadow:1px 1px 2px #3ec7f1 inset;
  }

  .form-select {
    width: 100%;
    padding: 6px 10px;
    font-size: 14px;
  }

  .form-select:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
  }

  .form-textarea {
    width: 100%;
    padding: 6px 10px;
    font-size: 14px;
    color: #333;
    background-color: #d9eef8;
    border: 1px solid #ddd;
    border-radius: 3px;
    resize: vertical;
    min-height: 80px;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    box-sizing: border-box;
  }

  .form-textarea:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
  }

  .form-checkbox {
    width: 16px;
    height: 16px;
    margin-right: 6px;
    vertical-align: middle;
    accent-color: #007bff;
  }

  .checkbox-group {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }

  .checkbox-label {
    font-size: 14px;
    color: #555;
    vertical-align: middle;
  }

  .error-message {
    display: block;
    margin-top: 3px;
    font-size: 11px;
    color: #dc3545;
  }

  /* Tag Input System */
  .tag-input-container {
    margin-bottom: 8px;
  }

  .tag-input-wrapper {
    display: flex;
    gap: 6px;
    margin-bottom: 6px;
  }

  .tag-input {
    flex: 1;
    padding: 6px 10px;
    font-size: 14px;
    border: 1px solid #ddd;
    border-radius: 3px;
    height: 34px;
    box-sizing: border-box;
  }

  .tag-button {
    padding: 6px 12px;
    background: #0d8fccff;
    color: #FFF;
    border: none;
    border-radius: 3px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;
    height: 34px;
    box-sizing: border-box;
  }

  .tag-button:hover {
    background-color: #0056b3;
  }

  .tags-container {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 6px;
  }

  .tag-item {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    padding: 3px 8px;
    border-radius: 3px;
    font-size: 12px;
    font-weight: 500;
  }

  .skill-tag {
    background: #0d8fccff;
    color: #FFF;
    border: 1px solid #bbdefb;
  }

  .certification-tag {
    background-color: #e8f5e9;
    color: #2e7d32;
    border: 1px solid #c8e6c9;
  }

  .remove-tag {
    background: none;
    border: none;
    color: inherit;
    font-size: 14px;
    cursor: pointer;
    padding: 0;
    margin-left: 3px;
    line-height: 1;
  }

  .remove-tag:hover {
    opacity: 0.7;
  }

  .no-items {
    font-size: 12px;
    color: #999;
  }

  /* Section Header */
  .section-header {
    font-size: 16px;
    font-weight: 600;
    color: #09779c;
    background: #e1e5e5;
    margin: 20px 0 12px 0;
    padding-bottom: 8px;
    border-bottom: 1px solid #eee;
  }

  /* Form Actions */
  .form-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #e0e0e0;
    background-color: white;
    padding: 16px 20px;
  }

  .reset-button {
    padding: 8px 16px;
    background-color: white;
    color: #555;
    border: 1px solid #ddd;
    border-radius: 3px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;
  }

  .reset-button:hover {
    background-color: #f8f9fa;
  }

  .save-button {
    padding: 8px 24px;
    background-image: linear-gradient(-180deg, #37AEE2 0%, #1E96C8 100%);
    color: #FFF;
    border: none;
    border-radius: 3px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;
  }

  .save-button:hover {
    background-color: #218838;
  }

  .save-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .cancel-button {
    padding: 8px 16px;
    background-color: white;
    color: #555;
    border: 1px solid #ddd;
    border-radius: 3px;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.2s;
  }

  .cancel-button:hover {
    background-color: #f8f9fa;
  }

  /* Alert Messages */
  .alert {
    padding: 10px 14px;
    border-radius: 3px;
    margin-bottom: 16px;
    font-size: 13px;
  }

  .alert-success {
    background-color: #d4edda;
    color: #155724;
    border: 1px solid #c3e6cb;
  }

  .alert-error {
    background-color: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
  }

  /* Field Group */
  .field-group {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 12px;
    margin-bottom: 16px;
  }

  /* Full Width Field */
  .full-width {
    grid-column: 1 / -1;
  }

  /* Readonly Field */
  .readonly-field {
    background-color: #f8f9fa;
    color: #666;
    cursor: not-allowed;
  }

  /* Date Input Styling */
  input[type="date"] {
    position: relative;
  }

  input[type="date"]::-webkit-calendar-picker-indicator {
    opacity: 0.6;
    cursor: pointer;
  }

  /* Phone Input */
  .phone-input {
    position: relative;
  }

  .phone-prefix {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: #666;
    font-size: 14px;
    pointer-events: none;
  }

  .phone-input input {
    padding-left: 40px;
  }
`;

// Dropdown options

// Dropdown options
const titleOptions = [
  { value: '', label: 'Choisir un titre' },
  { value: 'Mr', label: 'Mr' },
  { value: 'Mrs', label: 'Mrs' },
  { value: 'Ms', label: 'Ms' },
  { value: 'Dr', label: 'Dr' },
  { value: 'Prof', label: 'Prof' },
];

const genderOptions = [
  { value: '', label: 'Choisir un genre' },
  { value: 'Male', label: 'Masculin' },
  { value: 'Female', label: 'Féminin' },
  { value: 'Non-binary', label: 'Non-binaire' },
  { value: 'Prefer not to say', label: 'Préfère ne pas répondre' },
];

const pronounOptions = [
  { value: '', label: 'Choisir un pronom' },
  { value: 'He/Him', label: 'He/Him' },
  { value: 'She/Her', label: 'She/Her' },
  { value: 'They/Them', label: 'They/Them' },
  { value: 'Other', label: 'Other' },
];


const employeeTypeOptions = [
  { value: '', label: 'Choisir un type d\'employé' },
  { value: 'FULL_TIME', label: 'Temps Plein' },
  { value: 'PART_TIME', label: 'Temps Partiel' },
  { value: 'CONTRACTOR', label: 'Contractuel' },
  { value: 'INTERN', label: 'Stagiaire' },
  { value: 'TEMPORARY', label: 'Temporaire' },
  { value: 'FREELANCER', label: 'Freelance' },
  { value: 'CONSULTANT', label: 'Consultant' },
];

const employmentStatusOptions = [
  { value: '', label: 'Choisir un statut' },
  { value: 'ACTIVE', label: 'Actif' },
  { value: 'ON_LEAVE', label: 'En congé' },
  { value: 'SUSPENDED', label: 'Suspendu' },
  { value: 'TERMINATED', label: 'Résilié' },
  { value: 'RESIGNED', label: 'Démissionné' },
  { value: 'RETIRED', label: 'Retraité' },
  { value: 'PROBATION', label: 'Probation' },
];


// Tab definitions
const tabs = [
  { id: 'overview', label: 'Informations du contrat' },
  { id: 'address-contacts', label: 'Documents & Photos' },
];

// CSS Style component
const FormStyles = () => <style>{styles}</style>;

// User Create Form Component with Tabs
const TransferForm = () => {
  const [activeTab, setActiveTab] = useState('overview');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const fileTypes = ["JPG", "PNG", "ZIP"];
  const [file, setFile] = useState(null);
  const handlePermisChange = (file) => {
    setFile(file);
  };

  // Form state
  const [formData, setFormData] = useState({

    // Personal Tab
    title: '',
    firstName: '',
    lastName: '',
    dateOfBirth: '',
    gender: '',
    // Address & Contacts Tab
    idNumber: '',
    emissionNumber: '',
    insuranceNumber: '',
    cardNumber: '',

    emissionDate: '',
    effectDate: '',
    endDate: '',
    senderId: '',
    receiverId: '',

    netPrime: '',
    accessoires: '',
    totalPrime: '',
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));

    // Clear error for this field
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    // Required fields validation

    if (!formData.firstName) newErrors.firstName = 'First name is required';
    if (!formData.lastName) newErrors.lastName = 'Last name is required';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    setSubmitError('');
    setSubmitSuccess(false);

    try {
      const userData = {
        ...formData,
        dateOfBirth: formData.dateOfBirth ? new Date(formData.dateOfBirth).toISOString() : null,
        emissionDate: formData.emissionDate ? new Date(formData.emissionDate).toISOString() : null,
        effectDate: formData.effectDate ? new Date(formData.effectDate).toISOString() : null,
        endDate: formData.endDate ? new Date(formData.endDate).toISOString() : null,
      };

      // Call your API endpoint
      const response = await fetch('/api/users', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.error || 'Failed to create user');
      }

      setSubmitSuccess(true);

      // Auto-hide success message after 5 seconds
      setTimeout(() => setSubmitSuccess(false), 5000);
    } catch (error) {
      console.error('Error creating user:', error);
      setSubmitError(error.message || 'Failed to create user. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    setFormData({
      // Personal Tab
      title: '',
      firstName: '',
      lastName: '',
      dateOfBirth: '',
      gender: '',
      // Address & Contacts Tab
      idNumber: '',
      emissionNumber: '',
      insuranceNumber: '',
      cardNumber: '',

      emissionDate: '',
      effectDate: '',
      endDate: '',
      senderId: '',
      receiverId: '',

      netPrime: '',
      accessoires: '',
      totalPrime: '',
    });
    setErrors({});
    setSubmitError('');
    setSubmitSuccess(false);
  };

  return (
    <>
      <FormStyles />
      <div className="employee-form-container">
        <div className="form-header">
          <div className="form-title-row">
            <h1 className="form-title">Enregistrer une Emission</h1>
            <span className="form-subtitle">Non Sauvegardé</span>
          </div>
          <p className="form-status">Remplissez les détails du contrat ci-dessous. Les champs marqués d'une * sont obligatoires.</p>
        </div>

        {submitSuccess && (
          <div className="alert alert-success">
            Emission enregistrée avec succès!
          </div>
        )}

        {submitError && (
          <div className="alert alert-error">
            {submitError}
          </div>
        )}

        <div className="form-content">
          {/* Tabs Navigation */}
          <ul className="tabs-navigation">
            {tabs.map(tab => (
              <li
                key={tab.id}
                className={`tab-item ${activeTab === tab.id ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </li>
            ))}
          </ul>

          <form onSubmit={handleSubmit}>
            {/* Tab Content */}
            <div className="tab-content">

              {/* Overview Tab */}
              <div className={`tab-pane ${activeTab === 'overview' ? 'active' : ''}`}>
                <fieldset>
                  <legend>Informations du souscripteur</legend>
                  <div className="field-group">

                    <div className="form-group">
                      <label className="form-label required-label">Prénom(s) souscripteur</label>
                      <input
                        type="text"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="John"
                      />
                      {errors.firstName && (
                        <span className="error-message">{errors.firstName}</span>
                      )}
                    </div>

                    <div className="form-group">
                      <label className="form-label required-label">Nom de souscripteur</label>
                      <input
                        type="text"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="Doe"
                      />
                      {errors.lastName && (
                        <span className="error-message">{errors.lastName}</span>
                      )}
                    </div>

                    <div className="form-group">
                      <label className="form-label">Date de Naissance</label>
                      <input
                        type="date"
                        name="dateOfBirth"
                        value={formData.dateOfBirth}
                        onChange={handleChange}
                        className="form-input"
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label">Genre</label>
                      <select
                        name="gender"
                        value={formData.gender}
                        onChange={handleChange}
                        className="form-select"
                      >
                        {genderOptions.map(option => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="form-group">
                      <label className="form-label">CNIB/Passport/Permis</label>
                      <input
                        type="text"
                        name="idNumber"
                        value={formData.idNumber}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="123456789"
                      />
                    </div>
                  </div>
                </fieldset>
                <fieldset>
                  <legend>Informations de l'emission</legend>
                  <div className="field-group">
                    <div className="form-group">
                      <label className="form-label">Numero Emission</label>
                      <input
                        type="text"
                        name="emissionNumber"
                        value={formData.emissionNumber}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="123456789"
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label">Numero Attestation</label>
                      <input
                        type="text"
                        name="cardNumber"
                        value={formData.cardNumber}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="123456789"
                      />
                    </div>

                    <div className="form-group">
                      <label className="form-label">Agence Emetteur</label>
                      <input
                        type="text"
                        name="expeditionAgency"
                        value={formData.expeditionAgency}
                        onChange={handleChange}
                        className="form-input"
                        aria-disabled={true}
                        aria-readonly={true}
                        placeholder="Agence expediteur"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Agence destinataire</label>
                      <input
                        type="text"
                        name="agency"
                        value={formData.agency}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="Agence de destination"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Date d'emission</label>
                      <input
                        type="date"
                        name="emissionDate"
                        value={formData.emissionDate}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="date d'emission"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Numero Police</label>
                      <input
                        type="text"
                        name="insuranceNumber"
                        value={formData.insuranceNumber}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="Numero police"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Date d'effet</label>
                      <input
                        type="date"
                        name="effectDate"
                        value={formData.effectDate}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="Date d'effet"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Date d'echeance</label>
                      <input
                        type="date"
                        name="endDate"
                        value={formData.endDate}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="date d'echeance"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Prime Net</label>
                      <input
                        type="text"
                        name="netPrime"
                        value={formData.netPrime}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="Prime Net"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Accessoires</label>
                      <input
                        type="text"
                        name="accessoires"
                        value={formData.accessoires}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="Accessoires"
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Prime Total</label>
                      <input
                        type="text"
                        name="totalPrime"
                        value={formData.totalPrime}
                        onChange={handleChange}
                        className="form-input"
                        placeholder="423456789"
                      />
                    </div>
                  </div>
                </fieldset>
              </div>

              <div className={`tab-pane ${activeTab === 'address-contacts' ? 'active' : ''}`}>
                <fieldset>
                  <legend>Informations du souscripteur</legend>
                  <div className="field-group">
                    <div className="form-group">
                      <label className="form-label">CNIB/Passport</label>
                      <div className="phone-input">
                        <FileUploader handleChange={handlePermisChange} name="identites" types={fileTypes} />
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="form-label">Permis de Conduire</label>
                      <div className="phone-input">
                        <FileUploader handleChange={handlePermisChange} name="permis" types={fileTypes} />
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="form-label">Photos</label>
                      <div className="phone-input">
                        <FileUploader handleChange={handlePermisChange} name="photos" types={fileTypes} />
                      </div>
                    </div>
                  </div>
                </fieldset>
                <fieldset>
                  <legend>Informations du vehicule</legend>
                  <div className="field-group">
                    <div className="form-group">
                      <label className="form-label">Carte grise</label>
                      <FileUploader handleChange={handlePermisChange} name="cartes" types={fileTypes} />
                    </div>

                    <div className="form-group">
                      <label className="form-label">Visite technique</label>
                      <div className="phone-input">
                        <FileUploader handleChange={handlePermisChange} name="visites" types={fileTypes} />
                      </div>
                    </div>

                    <div className="form-group">
                      <label className="form-label">Photos du vehicules</label>
                      <FileUploader handleChange={handlePermisChange} name="vehicules" types={fileTypes} multiple={true} />
                    </div>
                  </div>
                </fieldset>
                <fieldset>
                  <legend>Dossier d'assurance</legend>
                  <div className="field-group">
                    <div className="form-group">
                      <label className="form-label">Conditions Particulieres</label>
                      <FileUploader handleChange={handlePermisChange} name="polices" types={fileTypes} />
                    </div>

                    <div className="form-group">
                      <label className="form-label">Attestation</label>
                      <FileUploader handleChange={handlePermisChange} name="attestations" types={fileTypes} dropMessageStyle={{ background: '#4193d6' }} />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Reçus</label>
                      <div className="phone-input">
                        <FileUploader handleChange={handlePermisChange} name="receipts" types={fileTypes} />
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>

            </div>

            {/* Form Actions */}
            <div className="form-actions">
              <button
                type="button"
                onClick={resetForm}
                className="reset-button"
              >
                Réinitialiser
              </button>
              <button
                type="button"
                className="cancel-button"
                onClick={() => window.history.back()}
              >
                Annuler
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="save-button"
              >
                {isSubmitting ? 'Enregistrement...' : 'Enregistrer l\'Emission'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default TransferForm;